import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { ChangeEvent, useEffect, useState } from 'react';

import { Spacing, Typography } from 'chatie-design-system';
import { Input } from 'chatie-design-system/form';
import { Close, Icon } from 'chatie-design-system/icon';

import { IChatCharacter } from '@model';
import { useWebView } from '@utils/webview';

import Modal, { ModalButton, ModalProps } from '../common/Modal';

const containerCSS = (theme: Theme) => css`
  overflow: scroll;

  .title {
    ${Typography.h4};
    text-align: center;
    line-height: 16px;
    font-weight: 700;
    margin-bottom: ${Spacing.xlarge}px;
    padding-top: ${Spacing.xhsmall}px;
  }
  .close {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  p {
    ${Typography.h5};
  }

  ul {
    display: flex;
    flex-direction: column;
    padding: 0 ${Spacing.medium}px;
    margin: ${Spacing.xlarge}px 0;
    gap: ${Spacing.xsmall}px;
  }

  ul > li {
    word-break: break-all;
    ${Typography.body14};
    list-style-type: disc;
    color: ${theme.colors.red500};
    line-height: 18.9px;
  }
`;

interface CharacterDeleteModalProps {
  handleOnConfirm: (characterId: number) => void;
  character: IChatCharacter;
}

const CharacterDeleteModal = ({
  handleOnConfirm,
  character,
  ...props
}: CharacterDeleteModalProps & ModalProps) => {
  const { t } = useTranslation();
  const { web } = useWebView();
  const [value, setValue] = useState<string>('');

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
  };
  useEffect(() => {
    web.setIsBottomInputPage(true);

    return () => {
      web.setIsBottomInputPage(false);
    };
  }, [web]);

  return (
    <Modal {...props} blocking={false} onClose={props.onClose} header={false}>
      <div css={containerCSS}>
        <div className="close" onClick={() => props.onClose()}>
          <Icon icon={Close} />
        </div>
        <div className="title">{t('캐릭터 삭제')}</div>
        <p>
          {t('정말 {{characterName}} 캐릭터를 삭제하시겠습니까?', {
            characterName: character.name,
          })}
        </p>
        <ul>
          <li>
            {t(
              '캐릭터 삭제 시 해당 캐릭터와 대화했던 모든 대화방이 삭제됩니다.'
            )}
          </li>
          <li>
            {t(
              '캐릭터 삭제를 원하신다면 캐릭터명을 아래 입력하신 후 삭제하기 버튼을 눌러주세요.'
            )}
          </li>
        </ul>
        <Input
          placeholder="캐릭터명을 입력해주세요"
          value={value}
          onChange={handleChangeInput}
        />
        <ModalButton
          text={t('삭제하기')}
          onClick={() => handleOnConfirm(character.id)}
          disabled={value !== character.name}
        />
      </div>
    </Modal>
  );
};

export default CharacterDeleteModal;
